const committedRemixCreateIds = new Set<string>();

export const remixCreateTerminalOwnership = {
	commit(remixCreateId: string): void {
		committedRemixCreateIds.add(remixCreateId);
	},
	isOwnedByTerminal(remixCreateId: string | undefined): boolean {
		return remixCreateId !== undefined && committedRemixCreateIds.has(remixCreateId);
	},
	release(remixCreateId: string | undefined): void {
		if (remixCreateId !== undefined) {
			committedRemixCreateIds.delete(remixCreateId);
		}
	},
	reset(): void {
		committedRemixCreateIds.clear();
	},
};
